import { apiClient } from '../client'
import { Agency, AgencyOffice, AgencyOfficeListResponse, CreateUpdateAgencyOfficePayload } from './types'

export const getAgency = async (): Promise<Agency> => {
    const response = await apiClient('v1/agency')
    return response.data
}

export const updateAgency = async (data: Record<string, unknown>): Promise<Agency> => {
    const response = await apiClient('v1/agency', {
        method: 'PUT',
        data,
    })
    return response.data
}

export const getAgencyOffices = async (): Promise<AgencyOfficeListResponse> => {
    const response = await apiClient('v1/agency-office?noLimit=1')
    return response.data
}

export const getAgencyOfficeById = async (id: string | number): Promise<AgencyOffice> => {
    const response = await apiClient(`v1/agency-office/${id}`)
    return response.data
}

export const createUpdateAgencyOffice = async ({ id, data }: CreateUpdateAgencyOfficePayload): Promise<AgencyOffice> => {
    const url = id ? `v1/agency-office/${id}` : 'v1/agency-office'

    const response = await apiClient(url, {
        method: id ? 'PUT' : 'POST',
        data,
    })
    return response.data
}
